module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/core-js/is-iterable.js
// module id = 1209
// module chunks = 1